import { useTranslation } from "react-i18next";
import { appPaths } from "../../../shared/routing/appPaths";
import { classNames } from "../../../ui/styles/classNames";
import StatusMessage from "../../../ui/feedback/StatusMessage";
import { glowsFor, GUIDE_STARTS_AT_ONCE, useConnectorSetup } from "./useConnectorSetup";
import ButtonLink from "../../../ui/buttons/ButtonLink";

/**
 * "Connect this PC", wherever a model is picked (F32) and on the Documents start page, where a
 * first visit lands (TR-A1-05): it leads to the guided setup while no
 * connector of the person's own PC is connected, and goes away once one is. A "DMW server" host
 * does not count. When nothing of theirs is connected at all, nothing can run, and it says that
 * the server's paid keys are only for the groups a project names (MA-C4; the server checks).
 * `inline`: the button alone, small, for a line that already says why (F55, a Thread's hosting line).
 */
export default function ConnectorSetupButton({ className, inline = false }: { className?: string; inline?: boolean }) {
  const { t } = useTranslation();
  const { state } = useConnectorSetup();
  if (state.status !== "loaded" || state.value.progress.pcConnectorOnline) {
    return null;
  }
  const { progress } = state.value;
  const button = (
    <ButtonLink to={appPaths.connectorSetup()} state={GUIDE_STARTS_AT_ONCE} size={inline ? "xs" : "sm"} className={classNames(glowsFor(state.value) && "app-connector-glow", inline && className)}>
      {t("connectors.setup.button.label")}
    </ButtonLink>
  );
  if (inline) return button;
  return (
    <div className={classNames("space-y-2", className)}>
      {progress.anyConnectorOnline ? null : (
        <StatusMessage tone="info" title={t("connectors.setup.button.nothingRunsTitle")}>
          <p>{t("connectors.setup.button.cloudNeedsPermission")}</p>
        </StatusMessage>
      )}
      {button}
    </div>
  );
}
